<template>
    <div class="right_box_main">
        <div class="card-box">
            <el-card :body-style="{ padding: '12px' }">
                <el-form :inline="true" :model="searchlist" size="mini">
                    <!-- 角色名查询 -->
                    <el-form-item label="角色名称:" style="margin: 0">
                        <el-input
                            placeholder="角色名称过滤"
                            v-model="searchlist.name"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item style="margin: 0">
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            @click="searchlistdata('')"
                            >查询</el-button
                        >
                    </el-form-item>
                    <el-form-item style="float: right; margin: 0">
                        <el-button type="primary" icon="el-icon-search"
                            >查询</el-button
                        >
                    </el-form-item>
                    <el-form-item
                        label="组织机构:"
                        style="float: right; margin: 0"
                    >
                        <el-input
                            placeholder="组织名称过滤"
                            v-model="filterText"
                        >
                        </el-input>
                    </el-form-item>
                </el-form>

                <div class="table_card" style="margin-top: 6px">
                    <el-table
                        size="middle"
                        :header-cell-style="{ background: '#f8fafa' }"
                        align="center"
                        height="45"
                    >
                        <el-table-column
                            align="center"
                            label="角色列表"
                            width="555px"
                        ></el-table-column>
                        <el-table-column
                            :render-header="renderHeader"
                            width="130px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            label="组织机构列表"
                        ></el-table-column>
                    </el-table>
                    <!-- 角色列表 -->
                    <el-table
                        :data="tableData"
                        class="roleTable"
                        border
                        align="center"
                        current-row-key
                        highlight-current-row
                    >
                        <el-table-column align="center" width="80px">
                            <template scope="scope">
                                <el-radio
                                    :label="scope.row.id"
                                    v-model="roleRadio"
                                    @change="getOrgDatas"
                                    >&nbsp;</el-radio
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="name"
                            label="角色名称"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="useable"
                            label="状态"
                        >
                            <template slot-scope="scope">
                                <span
                                    v-if="scope.row.useable == 1"
                                    style="color: #0f7ef1"
                                    >启用</span
                                >
                                <span
                                    v-if="scope.row.useable == 0"
                                    style="color: #cd2b20"
                                    >禁用</span
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 组织结构列表 -->
                    <el-tree
                        ref="tree"
                        class="filter-tree"
                        show-checkbox
                        :data="treedata"
                        :props="defaultProps"
                        node-key="id"
                        :filter-node-method="filterNode"
                        default-expand-all
                        :expand-on-click-node="false"
                        :render-content="renderContent"
                        :check-strictly="true"
                        :default-checked-keys="defaultCheckedKeys"
                    ></el-tree>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import "@/assets/css/system.css"
import request from "../../../utils/request.js"
export default {
    data() {
        return {
            searchlist: {},
            filterText: "",
            treedata: [],
            defaultProps: {
                children: "children",
                label: "label",
                disabled: function (data, node) {
                    return data.isValid != 1
                },
            },
            orgTypes: [
                { value: "1", label: "机构", disabled: true },
                { value: "2", label: "部门", disabled: true },
                { value: "3", label: "岗位", disabled: true },
                { value: "4", label: "人员", disabled: true },
            ],
            tableData: [],
            roleRadio: "",
            defaultCheckedKeys: [],
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
    },
    methods: {
        //table头部内容自定义
        renderHeader(h) {
            return (
                <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-check"
                    on-click={() => this.saveData()}
                >
                    保存组织分配
                </el-button>
            )
        },
        //树形列表
        filterNode(value, data) {
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        //树形结果显示内容自定义
        renderContent(h, { node, data, store }) {
            return (
                <span class="tree-span">
                    <span class="tree-span-label">
                        <el-tag type={data.css} size="small">
                            {data.tag}
                        </el-tag>
                        &nbsp;&nbsp;
                        {node.label}
                    </span>
                </span>
            )
        },
        async getTreeDatas() {
            var res = await request({
                url: "/rbac/admin/org/info/OrgTreelist",
                method: "POST",
                data: {isValid: 1,},
            })
            console.log(res.content)
            if (res.content.length > 0) {
                res.content.forEach((item) => {
                    var children = []
                    if (item.children != null && item.children.length > 0) {
                        children = this.formateTree(item.children)
                    }
                    //1.机构 2.部门 3.岗位 4.人员
                    var tag = "机构"
                    var css = ""
                    if (item.orgLevel == "2") {
                        tag = "部门"
                        css = "success"
                    } else if (item.orgLevel == "3") {
                        tag = "岗位"
                        css = "danger"
                    } else if (item.orgLevel == "4") {
                        tag = "人员"
                        css = "warning"
                    }

                    this.treedata.push({
                        id: item.orgId,
                        tag: tag,
                        css: css,
                        value: item.orgId,
                        label: item.label,
                        isValid: item.isValid,
                        children: children,
                    })
                })
            }
        },
        formateTree(arr) {
            var temp = []
            if (arr.length > 0) {
                arr.forEach((item) => {
                    var children = []
                    if (item.children != null && item.children.length > 0) {
                        children = this.formateTree(item.children)
                    }
                    //1.机构 2.部门 3.岗位 4.人员
                    var tag = "机构"
                    var css = ""
                    if (item.orgLevel == "2") {
                        tag = "部门"
                        css = "success"
                    } else if (item.orgLevel == "3") {
                        tag = "岗位"
                        css = "danger"
                    } else if (item.orgLevel == "4") {
                        tag = "人员"
                        css = "warning"
                    }
                    temp.push({
                        id: item.orgId,
                        tag: tag,
                        css: css,
                        value: item.orgId,
                        label: item.label,
                        isValid: item.isValid,
                        children: children,
                    })
                })
            }
            return temp
        },
        //根据角色查询关联的组织
        async getOrgDatas() {
            let params = JSON.stringify({ roleId: this.roleRadio })
            // console.log(params)
            var res = await request({
                url: "/admin/org/info/findOrgsByRoleId",
                method: "POST",
                data: params,
            })
            let defaultCheckedKeys_ = []
            if (res.code == 200) {
                if (res.content) {
                    res.content.forEach((item) => {
                        defaultCheckedKeys_.push(item.id)
                    })
                }
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            }
            this.defaultCheckedKeys = defaultCheckedKeys_
            this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys)
        },
        //条件查询
        searchlistdata() {
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            this.searchlist.pageNo = 1
            this.searchlist.pageSize = 20
            let params = JSON.stringify(this.searchlist)
            // console.log(params)
            var res = await request({
                url: "/admin/role/info/list",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                if (res.content != null) {
                    this.tableData = res.content.list
                } else {
                    this.tableData = []
                }
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常",
                    type: "error",
                })
            }
        },
        //保存到数据库
        async saveData() {
            let orgIds = this.$refs.tree.getCheckedKeys()
            if (orgIds.length < 1 || this.roleRadio == "") {
                this.$message({
                    message: "请选择要分配的组织",
                    type: "error",
                })
                return
            }
            let params = JSON.stringify({
                orgIds: orgIds,
                roleIds: [this.roleRadio],
            })
            console.log(params)
            var res = await request({
                url: "/admin/org/info/updateOrgRoleRelByRoleIdsAndOrgIds",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                this.$message({
                    message: "权限分配成功",
                    type: "success",
                })
                this.$emit("func", [])
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "分配失败：" + res.message,
                    type: "error",
                })
            }
        },
    },
    mounted() {
        // this.getOrgDatas()
        this.getTreeDatas()
        this.getPageDatas()
    },
}
</script>
<style lang="less" scoped>
// 深度穿透样式
/deep/ .el-tree {
    float: left;
    margin-left: 5%;
    width: 55%;
}
.roleTable {
    float: left;
    width: 40%;
}
/deep/ .el-tree-node__content {
    border: 1px solid #ebeef5 !important;
    border-top: 0px;
    height: 40px;
    line-height: 40px;
}
/deep/ .tree-span {
    font-size: 13px;
}
</style>